import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import {
    openLoginModal,
    setSiteScrollDisabled,
    openDepositWidget,
} from '~spa/Utils/WrapperIntegration/Ucf';

import {
    getPriceOdds,
} from '~shared/components/sport-event/utils.js';

import formatCurrency from '~shared/utils/currencyUtils';

import {
    isUserLoggedIn,
    shouldHideLogin,
    getEachwayAllowed,
    getUserTaxOnReturns,
} from '~shared/utils/user';

import {
    setFullScreenOn,
} from '~Betslip/slices/uiSlice';

import {
    updateSelection,
} from '~Betslip/slices/userSelectionsSlice';

import {
    updateUserParlay,
} from '~Betslip/slices/parlayTabSlice';

import {
    selectCountUserSelections,
    selectUserSelections,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    selectIsPlacingBet,
    selectShowGeoCheckMessage,
    selectIsBettingEnabled,
} from '~Betslip/selectors/uiSelectors';

import {
    selectParlay,
    selectUserParlay,
    selectPotentialReturnsMultiplier,
} from '~Betslip/selectors/parlaySelectors';

import {
    selectAnySelectionSuspended,
    selectSelectionDetailsById,
} from '~Betslip/selectors/selectionDetailsSelectors';

import {
    selectParlayParlayPayout,
} from '~Betslip/selectors/totalPayoutSelectors';

import {
    selectSinglePayout,
} from '~Betslip/selectors/singlesPayoutSelectors';

import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

import {
    selectBabyStake,
} from '~Betslip/selectors/totalStakeSelectors';

import { selectAvailableSingle } from '~Betslip/selectors/availableBetTypesSelectors';

import {
    selectUserBalance,
} from '~Betslip/selectors/userSelectors';

import {
    isDepositNeeded,
} from '~Betslip/utils/depositChecks';

import {
    selectRefreshReqCount,
} from '~Betslip/selectors/uiSelectors';

import {
    placeBet,
} from '~Betslip/thunks/placeBet';

import {
    selectAvailableFreebets,
} from '~Betslip/selectors/freeBetSelectors';

import {
    hasZeroBalance,
} from '~Betslip/utils/depositChecks';

import StakeField from '../Full/Components/StakeField';
import GeoLocationCheck from '../Full/Components/GeoLocationCheck';

import './styles/baby.scss';

const Baby = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();
    const loggedIn = isUserLoggedIn();
    const tax = getUserTaxOnReturns();
    const isPlacingBet = useSelector(selectIsPlacingBet);
    const showGeoCheckMessage = useSelector(selectShowGeoCheckMessage);

    let babyStake = useSelector(selectBabyStake);
    const count = useSelector(selectCountUserSelections);
    const parlay = useSelector(selectParlay);
    const single = useSelector(selectAvailableSingle);
    const anySelectionSuspended = useSelector(selectAnySelectionSuspended);
    const potentialReturnsMultiplier = useSelector(selectPotentialReturnsMultiplier);
    const isBettingEnabled = useSelector(selectIsBettingEnabled);

    const parlayUserBetDetail = useSelector(selectUserParlay);
    const parlayPayout = useSelector(selectParlayParlayPayout);

    const singleUserBetDetail = useSelector(selectUserSelections)[0]; //get the only user selection available
    const singlePayout = useSelector((state) => selectSinglePayout(state, singleUserBetDetail?.id, singleUserBetDetail?.free_bet_id));
    const singleSelectionDetails = useSelector((state) => selectSelectionDetailsById(state, singleUserBetDetail?.id));
    const refreshReqCount = useSelector(selectRefreshReqCount);
    const showLoadingAnimation = refreshReqCount > 0;

    const userBalance = useSelector(selectUserBalance);
    const userBetDetail = parlay ? parlayUserBetDetail : singleUserBetDetail;
    const userStake = userBetDetail?.stake ? userBetDetail.stake : 0;
    const payout = parlay ? parlayPayout : singlePayout;
    const betDetail = parlay ? parlay : singleSelectionDetails;
    const betslipId = parlay ? parlay?.id : singleUserBetDetail?.id;
    const availableFreeBets = useSelector((state) => selectAvailableFreebets(state, betslipId));

    const isFreeBetSelected = userBetDetail?.free_bet_id || 0;
    const isFreeBetAvailable = availableFreeBets.length > 0;

    const isEachWayAllowed = betDetail?.each_way_allowed && getEachwayAllowed();

    const { setKeyboardContainerRef, closeKeyboard } = useKeyboard();
    const keyboardRef = useRef();

    useEffect(() => {
        if(Number(babyStake) !== 0) {
            //Updates the stake if there are freebets available.
            if (isFreeBetAvailable) {
                babyStake = 0;
            }
            if (parlay) {
                dispatch(updateUserParlay({stake: babyStake}));
            } else {
                dispatch(updateSelection({
                    id: userBetDetail?.id,
                    stake: babyStake,
                }));
            }
        }
    }, [count, isFreeBetAvailable]);

    const enterFullScreenBetslip = () => {
        dispatch(setFullScreenOn());
        setSiteScrollDisabled(true);
    };

    const renderAvailableBetType = () => {
        if (parlay) {
            const betName = parlay.name;
            const specialCases = ['Doubles', 'Trebles'];
            if (!specialCases.includes(betName)) {
                return t(`bet_types.name.${betName}`);
            }

            return t(`betslip.acca_${betName}`);
        }

        return t('betslip.single');
    };

    const checkDepositNeeded = () => {
        let stake = userStake;
        if (userBetDetail.each_way_selected) {
            stake = stake * 2;
        }

        return isDepositNeeded(userBalance, stake);
    };

    const openKeyboard = () => {
        setKeyboardContainerRef(keyboardRef.current);
    };

    const updateUserChoices = (stake, each_way_selected, free_bet_id) => {
        const fbStake = (free_bet_id) ? 0 : stake;
        const data = { stake: fbStake, each_way_selected, free_bet_id };
        if (parlay) {
            dispatch(updateUserParlay(data));
        } else {
            dispatch(updateSelection({
                id: userBetDetail?.id,
                ...data,
            }));
        }
    };

    const openBetslipCTA = () => {
        return (
            <div
                onClick={enterFullScreenBetslip}
                className="babyslip__openFullslip"
                data-test-id="baby-betslip;expand-betslip"
                data-spectate-product="new-baby-betslip;expand-betslip"
            >
                <span className="babyslip__arrow"></span>
                <span
                    className="babyslip__counter"
                    data-test-id="baby-betslip;counter"
                >
                    {count}
                </span>
                <span>{t('betslip.betslip')}</span>
            </div>
        );
    };

    const checkDisabledCTA = () => {
        if (!loggedIn) {
            return false;
        }

        return Number(userBetDetail?.stake) === 0 && !userBetDetail?.free_bet_id;
    };

    const onClickHandler = () => {
        if (!loggedIn) {
            openLoginModal();
        } else if (checkDepositNeeded() || (hasZeroBalance(userBalance) && !isFreeBetSelected)) {
            openDepositWidget();
        }
        else if (!checkDisabledCTA() && !isPlacingBet) {
            dispatch(placeBet());
        }
    };

    const babyslipCTA = () => {
        let ctaText;
        let ctaGTM;

        const ctaClass = classNames('babyslip__cta',
        {
            'babyslip__cta--disabled': checkDisabledCTA() && !checkDepositNeeded() && !hasZeroBalance(userBalance),
            'babyslip__cta--loading': isPlacingBet,
        });

        if (!loggedIn) {
            ctaText = t('betslip.login');
            ctaGTM = 'new-baby-betslip;login';
        } else if (checkDepositNeeded() || (hasZeroBalance(userBalance) && !isFreeBetSelected)) {
            ctaText = t('betslip.deposit');
            ctaGTM = 'new-baby-betslip;deposit';
        } else {
            ctaText = t('betslip.place_bet');
            ctaGTM = 'new-baby-betslip;place-bet';
        }

        return <div
            className={ctaClass}
            onClick={onClickHandler}
            data-spectate-product={ctaGTM}
        >
            {ctaText}
        </div>;
    };

    const totalStakeEW = () => {
        const ewStake = Number(userBetDetail.stake) * 2;

        return (
            <div className="babyslip__total-stake">
                {t('betslip.total_stake')}: {formatCurrency(ewStake)}
            </div>
        );
    };

    if (!isBettingEnabled) {
        return null;
    }

    if (!showLoadingAnimation && (!count || !betDetail)) {
        return null;
    }

    if (shouldHideLogin()) {
        return <div className="babyslip babyslip__no-betslip">
            <i className="fullslip__no-betslip-icon"></i>
            <span>{t('betslip.app_download')}</span>
        </div>;
    }

    if (!showLoadingAnimation && ((!single && !parlay) || anySelectionSuspended)) {
        closeKeyboard();

        return (
            <div className="babyslip">
                {openBetslipCTA()}
                <div className="babyslip__open-message">{t('betslip.open_betslip')}</div>
            </div>
        );
    }

    const babySlipClass = classNames('babyslip',
    {
        'babyslip__placing-bet': isPlacingBet,
    });

    const gtmDetails = {
        source: 'new-baby-betslip',
        betType: betslipId,
    };

    const babyslipBody = () => {
        if (showGeoCheckMessage) {
            return <GeoLocationCheck displayHeader={false} />;
        }

        return <>
            <div className="babyslip__stake-section">
                {
                    showLoadingAnimation
                    ? <span className="babyslip__loading" />
                    : <span>
                        {renderAvailableBetType()}
                        <span className="babyslip__odds">
                            {
                                potentialReturnsMultiplier
                                ? getPriceOdds(potentialReturnsMultiplier, undefined, 2)
                                : t('betslip.sp')
                            }
                        </span>
                    </span>
                }
                {
                    userBetDetail
                    ? <StakeField
                        stake={userBetDetail.stake}
                        each_way_allowed={isEachWayAllowed}
                        each_way_selected={userBetDetail.each_way_selected}
                        onChangeCallback={updateUserChoices}
                        onClickHandler={openKeyboard}
                        disabled={anySelectionSuspended}
                        freebetId={userBetDetail.free_bet_id}
                        betslipId={betslipId}
                        gtmDetails={gtmDetails}
                        depositRequired={checkDepositNeeded()}
                    />
                    : null
                }
            </div>
            <div className="babyslip__place-bet-section">
                {
                    showLoadingAnimation
                    ? <span className="babyslip__loading" />
                    : <span>
                        {t('betslip.payout')} :
                        <span className="babyslip__payout">{formatCurrency(payout)}</span>
                        {
                            tax
                            ? <span className="babyslip__tax-indicator">
                                {`-${tax * 100}%`}
                            </span>
                            : null
                        }
                    </span>
                }
                {babyslipCTA()}
            </div>
        </>;
    };

    return (
        <>
            <div className="babyslip__keyboard-container" ref={keyboardRef} />
            {
                userBetDetail?.each_way_selected
                ? totalStakeEW()
                : null
            }
            <div className={babySlipClass}>
                {openBetslipCTA()}
                <div className="babyslip__details">
                    {babyslipBody()}
                </div>
            </div>
        </>
    );
};

export default Baby;
